import { Box, Divider, Menu, MenuItem, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import type { User } from '@tier4/webauto-auth-frontend-client';
import LogoutIcon from '@mui/icons-material/Logout';

type UserMenuProps = {
  user?: User;
  anchorEl: null | HTMLElement;
  isLogoutButtonDisabled: boolean;
  onClickLogout: () => void;
  onClose: () => void;
};

const UserMenu = ({
  user,
  anchorEl,
  isLogoutButtonDisabled,
  onClickLogout,
  onClose,
}: UserMenuProps) => {
  return (
    <Menu
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      sx={{ '.MuiList-root': { padding: 0 } }}
    >
      <Stack sx={{ px: 2.5, py: 2, gap: 2 }}>
        <Stack sx={{ gap: 1 }}>
          <Typography variant="body1" color="textSecondary" sx={{ fontWeight: 'bold' }}>
            ユーザー名
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 400 }}>
            {user?.profile.name}
          </Typography>
        </Stack>
        <Stack sx={{ gap: 1 }}>
          <Typography variant="body1" color="textSecondary" sx={{ fontWeight: 'bold' }}>
            Email
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 400 }}>
            {user?.profile.email}
          </Typography>
        </Stack>
      </Stack>
      <Divider />
      <MenuItem
        sx={{
          marginTop: 1,
          marginBottom: 1,
          paddingLeft: 2.5,
          paddingRight: 2.5,
        }}
        disabled={isLogoutButtonDisabled}
        onClick={onClickLogout}
      >
        <Stack direction="row" sx={{ alignItems: 'center', gap: 1 }}>
          <Box sx={{ height: 18 }}>
            <LogoutIcon fontSize="small" sx={{ color: '#575756' }} />
          </Box>
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            ログアウト
          </Typography>
        </Stack>
      </MenuItem>
    </Menu>
  );
};

export default memo(UserMenu);
